import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const unassignTeamLead = async (operatorSlackIds: string[]) => {
  const response = await mutationExecute({
    variables: {
      operatorSlackIds,
    },
    mutation: graphql(`
      mutation UnassignTeamLead($operatorSlackIds: [String!]!) {
        unassignTeamLead(operatorSlackIds: $operatorSlackIds)
      }
    `),
  });

  return response.data?.unassignTeamLead!;
};
